export default [
  {
    option: 'A',
    text: 'is 60 years of age or over or is under 16 years of age',
  },
  {
    option: 'B',
    text: 'is 16, 17 or 18 and in full time education',
  },
  {
    option: 'D',
    text: 'Maternity exemption certificate',
    validation: { type:  'cert_expiry'},
  },
  {
    option: 'E',
    text: 'Medical exemption certificate',
    validation: { type:  'cert_expiry'},
  },
  {
    option: 'F',
    text: 'Prescription prepayment certificate',
    validation: { type:  'cert_expiry'},
  },
  {
    option: 'W',
    text: 'HRT prescription prepayment certificate',
    validation: { type:  'cert_expiry', cert_number: {length: 11}},
    feature_flag: 'hrt_exemption_enabled'
  },
  {
    option: 'G',
    text: 'Prescription exemption certificate issued by Ministry of Defence',
  },
  {
    option: 'L',
    text: 'HC2 (full help) certificate',
    validation: { type:  'cert_expiry'},
  },
  {
    option: 'H',
    text: 'Income Support or Income-related Employment and Support Allowance',
    validation: { type:  'ni'},
  },
  {
    option: 'K',
    text: 'Income-based Jobseekers allowance',
    validation: { type:  'ni'},
  },
  {
    option: 'M',
    text: 'Tax Credit exemption certificate',
    validation: { type:  'cert_expiry'},
  },
  {
    option: 'S',
    text: 'Pension Credit Guarantee Credit (including partners)',
    validation: { type:  'ni'},
  },
  {
    option: 'U',
    text: 'Universal Credit and meets the criteria',
    validation: { type:  'ni'},
  },
];
